import React from 'react';
import NFTCard from '../components/NFTCard';

function LandingPage() {
  return (
    <div id="landing-page">
      <NFTCard></NFTCard>
    </div>
  )
}

export default LandingPage;